import { Component, OnInit, Input } from '@angular/core';
import { Category } from 'src/app/models/category';
import { ModalController } from '@ionic/angular';
import { CategoryAddEditModalComponent } from '../category-add-edit-modal/category-add-edit-modal.component';
import { Item } from 'src/app/models/item';
import { ItemAddEditModalComponent } from '../item-add-edit-modal/item-add-edit-modal.component';
import { take } from 'rxjs/operators';
import {ShopService} from "../../services/shop.service";
import {CategoryService} from "../../services/category.service";

@Component({
  selector: 'emc-category-card',
  templateUrl: './category-card.component.html',
  styleUrls: ['./category-card.component.scss'],
})
export class CategoryCardComponent implements OnInit {

  @Input() category: Category;

  constructor(
    private shopService: ShopService,
    private categoryService: CategoryService,
    private modalController: ModalController
  ) { }

  ngOnInit() {
    if (this.category.items) {
      this.category.items.sort((a, b) => a.name.localeCompare(b.name));
    }
  }

  async editSelf() {
    const modal = await this.modalController.create({
      component: CategoryAddEditModalComponent,
      backdropDismiss: false,
      componentProps: { category: { ...this.category } }
    });

    modal.onDidDismiss().then(async ({ data }) => {
      if (!data) { return; }

      this.shopService.getCurrentShop().subscribe(shop => {
        this.categoryService.updateCategory(data.category);
      });

      if (data.categoryToRemove) {
        this.categoryService.removeCategory(data.categoryToRemove.uid);
      }
    });

    await modal.present();
  }

  async editItem(item: Item, index: number) {
    const modal = await this.modalController.create({
      component: ItemAddEditModalComponent,
      backdropDismiss: false,
      componentProps: { item: { ...item } }
    });

    modal.onDidDismiss().then(async ({ data }) => {
      if (!data) { return; }

      if (data.item) {
        this.category.items[index] = data.item;
        this.updateSelf();
      }

      if (data.deleteItem) {
        this.category.items.splice(index, 1);
        this.updateSelf();
      }
    });

    await modal.present();
  }

  async addItem() {
    const modal = await this.modalController.create({
      component: ItemAddEditModalComponent,
      backdropDismiss: false,
    });

    modal.onDidDismiss().then(async ({ data }) => {
      if (!data || !data.item) { return; }

      console.log('check', this.category.items);
      if (!this.category.items) { this.category.items = []; }
      this.category.items.push(data.item);
      this.updateSelf();
    });

    await modal.present();
  }

  private updateSelf() {
    this.categoryService.updateCategory(this.category);
  }

}
